export function deviceCheck(): boolean {
  const userAgent = navigator.userAgent;
  if (userAgent && userAgent.toLowerCase().indexOf("macintosh") !== -1) { 
      return true
    } else if (userAgent && userAgent.toLowerCase().indexOf("windows") !== -1) {
      return true;
    } else {
      return false;
    } 
}